import IconContainer, { IconContainerProps } from "./IconContainer";

export default function IconWatchStatistic(props: IconContainerProps) {
    return <IconContainer {...props}>
        video_library
    </IconContainer>
}